export default "__VITE_ASSET__DRLtgaHD__"